import React, { useEffect, useState } from "react";
import {
  Grid,
  Select,
  styled,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { IHotel } from "@models";

interface Props {
  value?: number;
  onChange?: (value: number) => void;
  hotels: IHotel[]
}

const Container = styled(Grid)({
  display: "flex",
  flexDirection: "row",
});

const Title = styled(Typography)({
  color: "#111111",
  fontSize: "16px",
  fontWeight: "700",
  padding: "0 10px",
  alignSelf: "center",
  fontFamily: "Pretendard Variable, monospace",
});

const MainSelect = styled(Select)({
  height: "36px",
  minWidth: "150px",
  borderRadius: "5px",
  alignSelf: "center",
});

const FuncComponent: React.FC<Props> = ({ value = 0, onChange, hotels }) => {
  const { t } = useTranslation();
  const [defaultValue, setDefaultValue] = useState<number>(
    value || 0
  );

  const handleSelectChange = (event: SelectChangeEvent<any>) => {
    setDefaultValue(event.target.value);
    onChange &&
      onChange(event.target.value === 0 ? undefined : event.target.value);
  };

  useEffect(() => {
    setDefaultValue(value || 0);
  }, [value]);

  return (
    <Container>
      <Title sx={{ paddingBottom: 0 }}>{t("sidebar_menu.hotel_group")}</Title>
      <MainSelect
        displayEmpty
        value={defaultValue}
        onChange={handleSelectChange}
        defaultValue={defaultValue}
      >
        <MenuItem key={0} value={0}>
          {t("sidebar_menu.hotel_group_all")}
        </MenuItem>
        {hotels.map((_, index: number) => (
          <MenuItem key={index + 1} value={_.id}>
            {_.name}
          </MenuItem>
        ))}
      </MainSelect>
    </Container>
  );
};

export default FuncComponent;
